export default __webpack_public_path__ + "static/media/spheres-other.0c797dab.wav";